
import WebService from "../../WebService"

const LiveEvent = {
    gets(params) {
        return WebService.get("/console/contest/sessions?" + params)
    },
    get(id, e = null) {
        return WebService.get("/console/contest/sessions/" + id + '?e=' + e)
    },
    update(data) {
        return WebService.post("/console/contest/sessions/" + data.event_id, data)
    },
}
export default LiveEvent